import React, { useContext } from "react";
import { FormContext } from "./Form";
import { Informative } from "../../Inputs/General/Index";
import { PercentAvanceArea } from "./Styles";

export default function PercentProgress({ value, className = "" }) {
  /**
   * @type {{
   *    document:import("types/typedef/documents").DocumentI
   * }}
   */
  const { document } = useContext(FormContext);

  return (
    <>
      {className !== "" ? (
        <div>
          <Informative
            readonly={true}
            label="% Avance"
            value={!value ? document.progress.percentage.text : value}
          />
        </div>
      ) : (
        <PercentAvanceArea>
          <Informative
            readonly={true}
            label="% Avance"
            value={!value ? document.progress.percentage.text : value}
          />
        </PercentAvanceArea>
      )}
    </>
  );
}
